import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicFilterComponent } from './basic-filter/basic-filter.component';
import {PrimengModule} from '../primeng/primeng.module';
import { DropdownFilterComponent } from './dropdown-filter/dropdown-filter.component';
import { DateFilterComponent } from './date-filter/date-filter.component';
import { NumericFilterComponent } from './numeric-filter/numeric-filter.component';
import { IsactiveFilterComponent } from './isactive-filter/isactive-filter.component';
import {MultiSelectFilterComponent} from './multiselect-filter/multiselect-filter.component';


@NgModule({
  declarations: [BasicFilterComponent, DropdownFilterComponent, DateFilterComponent, NumericFilterComponent, IsactiveFilterComponent,MultiSelectFilterComponent],
  exports: [BasicFilterComponent, DropdownFilterComponent, DateFilterComponent, NumericFilterComponent, IsactiveFilterComponent,MultiSelectFilterComponent],
  imports: [
    CommonModule,
    PrimengModule
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class FiltersModule { }
